import React from 'react';
import { useFetchDisponibility } from '../../hooks/useFetchDisponibility';
import { AtCircularProgress } from '../../../../components/AtCircularProgress';
import { api_auth } from '../../../../common/globals/constants';
import { Gauge } from '../../../../components/IndividualCharts/Gauge/Gauge';
import {
  DYNAMIC_VIEW_REDUCER_ACTIONS,
  useDynamicViewState,
  useDynamicViewDispatch,
} from '../../context/dynamic-view-context';
import { format } from 'date-fns';
import { Box, Switch, Tooltip, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const URL_PARAMS = ({ objetivoId, periodo }) => {
  let fechaInicio = '';
  let fechaTermino = '';
  if (periodo.period === 'c') {
    fechaInicio = format(new Date(periodo.statePeriod.startDate), 'yyyy-MM-dd');
    fechaTermino = format(new Date(periodo.statePeriod.endDate), 'yyyy-MM-dd');
  }
  const token = sessionStorage.getItem('key');
  const user = sessionStorage.getItem('user');
  const URL = new URLSearchParams();
  URL.append('objetivoId', objetivoId);
  URL.append('t', periodo.period);
  URL.append('user', user);
  URL.append('token', token);
  URL.append('key', api_auth);
  URL.append('fechaInicio', fechaInicio);
  URL.append('fechaTermino', fechaTermino);
  return URL;
};

export const GaugeChart = React.memo(function GaugeChart({
  objetivoId,
  real,
  excluirSinMonitoreo,
}) {
  const { t } = useTranslation();
  const { filterPeriod, refreshTime, activeLayout } = useDynamicViewState();
  const dispatch = useDynamicViewDispatch();

  const {
    data: dataDisponibility,
    isLoading,
    error,
    isFetching,
  } = useFetchDisponibility({
    urlParams: URL_PARAMS({ objetivoId, periodo: filterPeriod }),
    fetchApi:
      filterPeriod.period === 'c'
        ? 'getDisponibilityCustom'
        : 'getDisponibility',
    refreshTime,
  });

  const [
    excluirSinMonitoreoState,
    setExcluirSinMonitoreoState,
  ] = React.useState(excluirSinMonitoreo);

  function handleChangeWithoutNoMon() {
    setExcluirSinMonitoreoState(!excluirSinMonitoreoState);
    const newLayout = [...activeLayout].map((slot) => {
      if (slot.objetivoId === objetivoId) {
        return {
          ...slot,
          customParams: {
            excluirSinMonitoreo: !excluirSinMonitoreoState,
          },
        };
      }
      return slot;
    });
    dispatch({
      type: DYNAMIC_VIEW_REDUCER_ACTIONS.UPDATE_TEMPLATE,
      payload: newLayout,
    });
  }

  if (isLoading || isFetching) return <AtCircularProgress />;
  if (error) return <div>{t('dynamicPanel.gaugeChart.errorLoading')}</div>;

  return (
    <Box style={{ width: '100%' }}>
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          padding: 4,
        }}
      >
        <Typography>
          {t('dynamicPanel.gaugeChart.excludeNoMonitoring')}
        </Typography>
        <Switch
          checked={excluirSinMonitoreo}
          onChange={handleChangeWithoutNoMon}
          value="checkedA"
          inputProps={{ 'aria-label': 'secondary checkbox' }}
          color="primary"
        />
      </Box>
      <Box>
        <Gauge
          data={dataDisponibility.data}
          real={real}
          excluirSinMonitoreo={excluirSinMonitoreoState}
          refreshTime={refreshTime}
          objetivoId={objetivoId}
        />
      </Box>
    </Box>
  );
});
